import LandingScreen from "@/components/landing/LandingPage";

export default function LandingPage() {
  return <LandingScreen />;
}
